<template>
  <div>
    <v-text-field v-model="text" placeholder="Поиск (Ф.И.О., Телефон, Сообщение)..." hide-details flat solo clearable>
      <template v-slot:prepend-inner>
        <v-icon>mdi-magnify</v-icon>
      </template>
    </v-text-field>
  </div>

</template>

<script>
export default {
  mounted() {
    let s = this.$tools.storageGet('dialogPageSearch_text');
    if(!this.$tools.isEmpty(s)){
      this.text = s;
      this.$tools.storageSet('dialogPageSearch_text')
    }
  },
  data: () => ({
    text: null,
  }),
  watch:{
    text() {
      this.$tools.debounce(()=> {
        this.$emit('update:text', this.text)
      }, 1000, 'dialogPageSearch')
    }
  }
}
</script>